module.exports = __webpack_public_path__ + "img/main-9.b7dbec55.jpg";